export enum ReadType {
	BLOB = 'blob',
	DATA_URL = 'dataUrl',
	BASE64 = 'base64'
}
export async function read(file, readType: ReadType) {
	return new Promise<any>((resolve, reject) => {
		let reader = new FileReader()
		let preprocess: any = undefined
		reader.onloadend = () => {
			resolve(reader.result)
		}
		reader.onerror = (err) => {
			reject(err)
		}
		switch (readType) {
			case ReadType.BLOB: {
				reader.readAsArrayBuffer(file)
				break
			}
			case ReadType.BASE64: {
				preprocess = (result: string) => {
					return result.substr(result.indexOf(',') + 1)
				}
				reader.readAsDataURL(file)
				break
			}
			case ReadType.DATA_URL:
			default: {
				reader.readAsDataURL(file)
				break
			}
		}
	})
}

export async function loadImage(img: string) {
	return new Promise<HTMLImageElement>((resolve, reject) => {
		let image = new Image()
		image.onload = () => {
			resolve(image)
		}
		image.onerror = reject
		image.src = img
	})
}



// WEBPACK FOOTER //
// ./src/utils/ReaderUtils.ts